<template>
  <div class="white elevation-2">
    <v-toolbar
      color="#0065BD"
      flat
      dark
    >
      <v-toolbar-title>{{ title }}</v-toolbar-title>
      <slot name="action" />
    </v-toolbar>

    <div class="pl-2 pr-2 ml-2 mr-2 mb-2 mt-3">
      <slot>
        No {{ title }} results.
      </slot>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    title: {
      type: String,
      default: '',
      required: true,
      }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/globals/Panel.vue